import { RootState } from 'redux/reducers/rootReducer';

const countriesSelector = (state: RootState) => state.region.countries;

export { countriesSelector };
